<template>
  <div class="banner_container" style="background: #fff; height: 100%">
    <!-- 标题 -->
    <div class="banner_title">
      <!-- <div class="title">BANNER管理</div> -->
      <!--      <div class="btns">
        <a-button type="primary" @click="publishSet">审核设置</a-button>
        <a-button type="primary" @click="timeSet">轮播时间设置</a-button>
      </div>-->
    </div>
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="手机号">
              <a-input
                placeholder="请输入手机号"
                v-model="queryParam.fundCode"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="发送状态">
              <j-dict-select-tag
                placeholder="请选择发送状态"
                v-model="queryParam.checkStatus"
                dictCode="quotation_checkStatus"
              />
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :xl="10" :lg="11" :md="12" :sm="24">
              <a-form-item label="发送时间">
                <j-date
                  placeholder="请选择开始日期"
                  class="query-group-cust"
                  v-model="queryParam.beginDate_begin"
                ></j-date>
                <span class="query-group-split-cust"></span>
                <j-date
                  placeholder="请选择结束日期"
                  class="query-group-cust"
                  v-model="queryParam.beginDate_end"
                ></j-date>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="短信标题">
                <a-input
                  placeholder="请输入短信标题"
                  v-model="queryParam.fundCode"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <a-form-item label="客户名称">
                <a-input
                  placeholder="请输入客户名称"
                  v-model="queryParam.fundCode"
                ></a-input>
              </a-form-item>
            </a-col>
          </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    <!-- 按钮 -->
    <div class="banner_btns">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" @click="historyHandle">草稿箱</a-button>
      <a-button type="primary" @click="addHandle">新增</a-button>
      <a-button type="primary" @click="addHandle">自定义短信发送</a-button>
      <a-button type="primary" @click="addHandle">发送单条短信</a-button>
      <a-button type="primary" @click="batchDel">批量删除</a-button>
      <!-- <a-button type="primary" @click="batchShelve('1')">批量上架</a-button>
      <a-button type="primary" @click="batchShelve('0')">批量下架</a-button>
      <a-button type="primary" @click="batchAudit('1')">审核通过</a-button>
      <a-button type="primary" @click="batchAudit('0')">审核驳回</a-button> -->
      <!-- <a-button type="primary" @click="publishSet">审核设置</a-button>
      <a-button type="primary" @click="timeSet">轮播时间设置</a-button> -->
    </div>
    <!-- 表格 -->
    <a-table
      :columns="columns"
      :data-source="bannerList"
      rowKey="id"
      @change="onChange"
      :loading="loading"
      :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange
      }"
      bordered
      :pagination="false"
    >
      <template slot="operation" slot-scope="text, record">
        <a href="javascript:;" @click="editBanner(record, record.id)">修改</a
        >&nbsp;
        <a href="javascript:;" @click="onDelete(record.id)">删除</a> &nbsp;
        <a
          href="javascript:;"
          v-if="record.auditStatus == '0'"
          @click="auditBanner(record)"
          >审核</a
        >
      </template>
      <template slot="publicStatus" slot-scope="text, record">
        <a-switch
          v-model="record.statusBl"
          :disabled="isDisabled(record.auditStatus)"
          checked-children="上架"
          un-checked-children="已下架"
          @click="handleShelve(record)"
        />
      </template>
      <template slot="pic" slot-scope="text, record">
        <img :src="record.pic" alt="" style="width: 80px; height: 40px" />
      </template>
      <template slot="auditStatus" slot-scope="text, record">
        <span v-if="record.auditStatus === '0'">未审核</span>
        <span v-else-if="record.auditStatus === '1'">审核成功</span>
        <span v-else-if="record.auditStatus === '2'">审核驳回</span>
      </template>
    </a-table>
    <!-- 分页 -->
    <a-pagination
      style="float: right"
      v-model="query.pageNo"
      :page-size-options="query.pageSizeOptions"
      :total="query.total"
      show-size-changer
      showQuickJumper
      :page-size="query.pageSize"
      @showSizeChange="onShowSizeChange"
      @change="onChangeCurrent"
      :show-total="
        (total, range) => `${range[0]}-${range[1]}${'共'} ${total}${'条'}`
      "
    >
      <template slot="buildOptionText" slot-scope="props">
        <span v-if="props.value !== '50'">{{ props.value }}条/页</span>
        <span v-if="props.value === '50'">全部</span>
      </template>
    </a-pagination>

    <!-- 草稿箱 -->
    <a-modal
      v-model="historyVisible"
      title="草稿箱"
      @ok="historyHandleOk"
      @cancel="historyCancel"
    >
      <a-form-model
        ref="settingRuleForm"
        :model="settingForm"
        :rules="settingRules"
        :label-col="{ settinglabelCol }"
        :wrapper-col="settingwrapperCol"
      >
        <a-form-model-item label="短信或邮件标题：" prop="type">
          <a-input
            v-model="settingForm.type"
            style="width: 120px; margin-left: 20px"
          />
        </a-form-model-item>
        <a-form-item label="创建日期">
          <j-date
            placeholder="请选择开始日期"
            class="query-group-cust"
            v-model="queryParam.beginDate_begin"
          ></j-date>
          <span class="query-group-split-cust"></span>
          <j-date
            placeholder="请选择结束日期"
            class="query-group-cust"
            v-model="queryParam.beginDate_end"
          ></j-date>
        </a-form-item>
      </a-form-model>
      <span
        style="float: left; overflow: hidden"
        class="table-page-search-submitButtons"
      >
        <a-button type="primary" @click="searchQuery" icon="search"
          >查询</a-button
        >
        <a-button
          type="primary"
          @click="searchReset"
          icon="reload"
          style="margin-left: 8px"
          >重置</a-button
        >
        <!-- <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a> -->
      </span>
      <div class="banner_container" style="background: #fff; height: 70%">
        <!-- 表格 -->
        <a-table
          :columns="historyColumns"
          :data-source="bannerList"
          rowKey="id"
          @change="onChange"
          :loading="loading"
          :row-selection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange
          }"
          bordered
          :pagination="false"
        >
          <template slot="operation" slot-scope="text, record">
            <a href="javascript:;" @click="editBanner(record, record.id)"
              >修改</a
            >&nbsp;
            <a href="javascript:;" @click="onDelete(record.id)">删除</a> &nbsp;
            <a
              href="javascript:;"
              v-if="record.auditStatus == '0'"
              @click="auditBanner(record)"
              >审核</a
            >
          </template>
          <template slot="publicStatus" slot-scope="text, record">
            <a-switch
              v-model="record.statusBl"
              :disabled="isDisabled(record.auditStatus)"
              checked-children="上架"
              un-checked-children="已下架"
              @click="handleShelve(record)"
            />
          </template>
          <template slot="pic" slot-scope="text, record">
            <img :src="record.pic" alt="" style="width: 80px; height: 40px" />
          </template>
          <template slot="auditStatus" slot-scope="text, record">
            <span v-if="record.auditStatus === '0'">未审核</span>
            <span v-else-if="record.auditStatus === '1'">审核成功</span>
            <span v-else-if="record.auditStatus === '2'">审核驳回</span>
          </template>
        </a-table>
        <!-- 分页 -->
        <a-pagination
          style="float: right"
          v-model="query.pageNo"
          :page-size-options="query.pageSizeOptions"
          :total="query.total"
          show-size-changer
          showQuickJumper
          :page-size="query.pageSize"
          @showSizeChange="onShowSizeChange"
          @change="onChangeCurrent"
          :show-total="
            (total, range) => `${range[0]}-${range[1]}${'共'} ${total}${'条'}`
          "
        >
          <template slot="buildOptionText" slot-scope="props">
            <span v-if="props.value !== '50'">{{ props.value }}条/页</span>
            <span v-if="props.value === '50'">全部</span>
          </template>
        </a-pagination>
      </div>
    </a-modal>

    <!-- 审核设置对话框 -->
    <a-modal
      v-model="settingVisible"
      title="审核设置"
      @ok="historyHandleOk"
      @cancel="historyCancel"
    >
      <a-form-model
        ref="settingRuleForm"
        :model="settingForm"
        :rules="settingRules"
        :label-col="settinglabelCol"
        :wrapper-col="settingwrapperCol"
      >
        <a-form-model-item label="选择类型：" prop="type">
          <a-select
            v-model="settingForm.type"
            style="width: 120px"
            @change="handleTypeChange"
          >
            <a-select-option value="">请选择</a-select-option>
            <a-select-option
              v-for="(item, index) in typeList"
              :key="index"
              :value="item"
            >
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="创建是否需要审核：">
          <a-radio-group
            name="radioGroup"
            v-model="settingForm.createNeedAudit"
          >
            <a-radio value="1"> 是 </a-radio>
            <a-radio value="0"> 否 </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="修改是否需要审核：">
          <a-radio-group name="radioGroup" v-model="settingForm.editNeedAudit">
            <a-radio value="1"> 是 </a-radio>
            <a-radio value="0"> 否 </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="审核人是否能与发布人一致：">
          <a-radio-group
            name="radioGroup"
            v-model="settingForm.auditorSamePublisher"
          >
            <a-radio value="1"> 是 </a-radio>
            <a-radio value="0"> 否 </a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 轮播时间设置 -->
    <a-modal v-model="timeVisible" title="轮播时间设置" @ok="timeHandleOk">
      <a-form-model
        ref="settingRuleForm"
        :model="timeForm"
        :rules="settingRules"
        :label-col="settinglabelCol"
        :wrapper-col="settingwrapperCol"
      >
        <a-form-model-item label="选择类型：" prop="type">
          <a-select
            v-model="timeForm.type"
            style="width: 120px"
            @change="handleChangeTypeTime"
          >
            <a-select-option value="">请选择</a-select-option>
            <a-select-option
              v-for="(item, index) in typeList"
              :key="index"
              :value="item.type"
            >
              {{ item.type }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="时间(单位秒)：" prop="stayTime">
          <a-input v-model="timeForm.stayTime" style="width: 150px" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 新增banner -->
    <a-modal
      v-model="addVisible"
      title="新增"
      @ok="addHandleOk"
      @cancel="addCancel"
    >
      <a-form-model
        ref="bannerRuleForm"
        :model="bannerForm"
        :rules="bannerRules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <!-- banner分类 -->
        <a-form-model-item label="banner分类：" prop="type">
          <a-select
            placeholder="请选择"
            v-model="bannerForm.type"
            style="width: 120px"
          >
            <a-select-option value="">请选择</a-select-option>
            <a-select-option
              v-for="(item, index) in typeList"
              :key="index"
              :value="item.type"
            >
              {{ item.type }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <!-- 排序 -->
        <a-form-model-item label="排序：" prop="showIndex">
          <a-input
            v-model="bannerForm.showIndex"
            style="width: 100px; margin-bottom: 20px"
          />
        </a-form-model-item>
        <!-- 标题 -->
        <a-form-model-item label="banner标题：" prop="title">
          <a-input
            :max-length="50"
            placeholder="请输入banner标题,限制50个字"
            v-model="bannerForm.title"
            style="width: 300px"
          />
        </a-form-model-item>
        <!-- 跳转地址 -->
        <a-form-model-item label="点击跳转：">
          <a-radio-group
            v-model="bannerForm.jumpType"
            @change="handleFundChange"
          >
            <a-radio-button value="0"> 产品详情 </a-radio-button>
            <a-radio-button value="1"> PC产品详情 </a-radio-button>
            <a-radio-button value="2"> URL </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <!-- 产品详情 -->
        <a-form-model-item
          v-if="bannerForm.jumpType === '0' || bannerForm.jumpType === '1'"
          label="跳转产品详情："
        >
          <a-select
            v-model="bannerForm.fundCode"
            placeholder="请选择"
            style="width: 210px"
            @change="handleFundChange"
            show-search
          >
            <a-select-option value="">请选择</a-select-option>
            <a-select-option
              v-for="(item, index) in fundList"
              :key="index"
              :value="item.fundCode"
            >
              {{ item.fundCode }} / {{ item.fundName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          v-if="
            bannerForm.jumpType === '2' ||
              bannerForm.jumpType === '0' ||
              bannerForm.jumpType === '1'
          "
          label="跳转URL："
        >
          <a-input v-model="bannerForm.jumpTarget" style="width: 300px" />
        </a-form-model-item>
        <!-- 打开方式 -->
        <a-form-model-item label="打开方式：">
          <a-radio-group v-model="bannerForm.openType" @change="openChange">
            <a-radio-button value="0"> 当前窗口 </a-radio-button>
            <a-radio-button value="1"> 新窗口 </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <!-- 上传图片 -->
        <a-form-model-item label="上传图片：" prop="pic">
          <j-image-upload
            class="avatar-uploader"
            file-type="file"
            fileKey="file"
            url="system-biz/sys/upload/uploadMinio"
            text="上传"
            v-model="bannerForm.pic"
          ></j-image-upload>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 筛选 -->
    <a-modal v-model="screenVisible" title="筛选" footer="">
      <!-- 类型 -->
      <div>
        类型：
        <a-select
          v-model="screen.type"
          placeholder="请选择"
          style="width: 200px"
        >
          <a-select-option
            v-for="(item, index) in typeList"
            :key="index"
            :value="item.type"
          >
            {{ item.type }}
          </a-select-option>
        </a-select>
      </div>
      <!-- 标题 -->
      <div style="margin-top: 20px">
        标题：
        <a-input v-model="screen.title" style="width: 300px" />
      </div>
      <div style="margin: 40px 0 0 260px">
        <a-button
          type="primary"
          @click="searchReset"
          icon="reload"
          style="margin-left: 8px"
          >重置</a-button
        >
        <a-button
          type="primary"
          @click="goSearch"
          icon="search"
          style="margin-left: 10px"
          >搜索</a-button
        >
      </div>
    </a-modal>

    <!-- 修改banner -->
    <a-modal v-model="editVisible" title="修改" @ok="editHandleOk">
      <a-form-model
        ref="editRuleForm"
        :model="editForm"
        :rules="editRules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <!-- banner分类 -->
        <a-form-model-item label="banner分类：" prop="type">
          <a-select default-value="1" style="width: 120px" disabled>
            <a-select-option value="1">
              {{ editForm.type }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <!-- 排序 -->
        <a-form-model-item label="排序：" prop="showIndex">
          <a-input v-model="editForm.showIndex" style="width: 100px" />
        </a-form-model-item>
        <!-- 标题 -->
        <a-form-model-item label="banner标题：" prop="title">
          <a-input
            :max-length="50"
            v-model="editForm.title"
            style="width: 300px"
          />
        </a-form-model-item>
        <!-- 跳转地址 -->
        <a-form-model-item label="点击跳转：">
          <a-radio-group v-model="editForm.jumpType" @change="handleFundChange">
            <a-radio-button value="0"> 产品详情 </a-radio-button>
            <a-radio-button value="1"> PC产品详情 </a-radio-button>
            <a-radio-button value="2"> URL </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <!-- 跳转产品详情 -->
        <a-form-model-item
          label="跳转产品详情："
          v-if="editForm.jumpType === '0' || editForm.jumpType === '1'"
        >
          <a-select
            v-model="editForm.fundCode"
            placeholder="请选择"
            style="width: 210px"
            @change="handleFundChange"
            show-search
          >
            <a-select-option value="">请选择</a-select-option>
            <a-select-option
              v-for="(item, index) in fundList"
              :key="index"
              :value="item.fundCode"
            >
              {{ item.fundCode }}/{{ item.fundName }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          label="跳转URL："
          v-if="
            editForm.jumpType === '0' ||
              editForm.jumpType === '2' ||
              editForm.jumpType === '1'
          "
        >
          <a-input v-model="editForm.jumpTarget" style="width: 300px" />
        </a-form-model-item>
        <!-- 打开方式 -->
        <a-form-model-item label="打开方式：">
          <a-radio-group v-model="editForm.openType" @change="openChange">
            <a-radio-button value="0"> 当前窗口 </a-radio-button>
            <a-radio-button value="1"> 新窗口 </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <!-- 轮播图片 -->
        <a-form-model-item label="轮播图片:" prop="pic">
          <div class="img_item" style="margin: 10px 0">
            <img
              :src="editForm.pic"
              alt=""
              style="width: 100px; height: 60px"
            />
          </div>
          <!-- 还需要设置请求头headers -->
          <j-image-upload
            class="avatar-uploader"
            text="修改图片"
            v-model="editForm.pic"
          ></j-image-upload>
        </a-form-model-item>
        <!-- 修改设置 -->
        <a-form-model-item
          label="修改设置："
          prop="type"
          v-if="editForm.editNeedAudit === '1' && editForm.status === '1'"
        >
          <a-switch v-model="editForm.editUnshelves" @change="onChange" />
          修改后旧版立即下架
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 单独一个banner审核 -->
    <a-modal
      v-model="checkVisible"
      title="审核"
      @cancel="checkVisible == false"
    >
      <template slot="footer">
        <a-button @click="checkHandleOk('0')">审核驳回</a-button>
        <a-button type="primary" @click="checkHandleOk('1')">审核通过</a-button>
      </template>
      <a-form-model
        ref="editRuleForm"
        :model="editForm"
        :rules="editRules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <!-- banner分类 -->
        <a-form-model-item label="banner分类：" prop="type">
          <a-select default-value="1" style="width: 120px" disabled>
            <a-select-option value="1">
              {{ editForm.type }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <!-- 排序 -->
        <a-form-model-item label="排序：" prop="showIndex">
          <a-input
            :disabled="true"
            v-model="editForm.showIndex"
            style="width: 100px"
          />
        </a-form-model-item>
        <!-- 标题 -->
        <a-form-model-item label="banner标题：" prop="title">
          <a-input
            :disabled="true"
            v-model="editForm.title"
            style="width: 300px"
          />
        </a-form-model-item>
        <!-- 跳转地址 -->
        <a-form-model-item label="点击跳转：">
          <a-radio-group :disabled="true" v-model="editForm.jumpType">
            <a-radio-button value="0"> 产品详情 </a-radio-button>
            <a-radio-button value="1"> PC产品详情 </a-radio-button>
            <!--<a-radio-button value="1">
              文章
            </a-radio-button>-->
            <a-radio-button value="2"> URL </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <!-- 跳转栏目 -->
        <a-form-model-item
          label="跳转产品详情："
          v-if="editForm.jumpType === '0' || editForm.jumpType === '1'"
        >
          <a-select
            disabled
            v-model="editForm.fundCode"
            style="width: 210px"
            @change="handleFundChange"
          >
            <a-select-option value="">请选择</a-select-option>
            <a-select-option
              v-for="(item, index) in fundList"
              :key="index"
              :value="item.fundCode"
            >
              {{ item.fundCode }}/{{ item.fundName }}
            </a-select-option>
          </a-select>
          <a-input
            disabled
            v-model="editForm.jumpTarget"
            style="width: 300px"
          />
        </a-form-model-item>
        <a-form-model-item label="跳转URL：" v-if="editForm.jumpType === '2'">
          <a-input
            disabled
            v-model="editForm.jumpTarget"
            style="width: 300px"
          />
        </a-form-model-item>
        <!-- 打开方式 -->
        <a-form-model-item label="打开方式：">
          <a-radio-group
            disabled
            v-model="editForm.openType"
            @change="openChange"
          >
            <a-radio-button value="0"> 当前窗口 </a-radio-button>
            <a-radio-button value="1"> 新窗口 </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <!-- 轮播图片 -->
        <a-form-model-item label="轮播图片:" prop="pic">
          <div class="img_item" style="margin: 10px 0">
            <img
              :src="editForm.pic"
              alt=""
              style="width: 100px; height: 60px"
            />
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import '@/assets/less/TableExpand.less';
import SMSServiceModal from './modules/SMSServiceModal';
import { mixinDevice } from '@/utils/mixin';
import JDate from '@/components/jeecg/JDate';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import JImageUpload from '@/components/jeecg/JImageUpload';
import { getAction, postAction } from '@/api/manage';

const columns = [
  {
    title: '序号',
    dataIndex: 'key',
    key: 'key',
    defaultSortOrder: 'ascend',
    sorter: (a, b) => a.key - b.key
  },
  {
    ellipsis: true,
    align: 'center',
    title: '发送时间',
    dataIndex: 'title',
    key: 'title',
    sortDirections: ['descend', 'ascend'],
    sorter: (a, b) => a.title.length - b.title.length
  },
  {
    ellipsis: true,
    align: 'center',
    title: '手机号',
    dataIndex: 'pic',
    key: 'pic',
    sorter: (a, b) => a.type.length - b.type.length,
    sortDirections: ['descend', 'ascend']
  },
  {
    ellipsis: true,
    align: 'center',
    title: '客户名称',
    dataIndex: 'type',
    key: 'type',
    sorter: (a, b) => a.type.length - b.type.length,
    sortDirections: ['descend', 'ascend']
  },
  {
    ellipsis: true,
    align: 'center',
    title: '短信状态',
    dataIndex: 'auditStatus',
    key: 'auditStatus',
    scopedSlots: { customRender: 'auditStatus' },
    sorter: (a, b) => a.auditStatus - b.auditStatus,
    sortDirections: ['descend', 'ascend']
  },
  {
    ellipsis: true,
    align: 'center',
    title: '短信内容',
    dataIndex: 'type',
    key: 'type',
    sorter: (a, b) => a.type.length - b.type.length,
    sortDirections: ['descend', 'ascend']
  },
  {
    title: '操作',
    key: 'operation',
    scopedSlots: { customRender: 'operation' }
  }
];

const historyColumns = [
  {
    title: '序号',
    dataIndex: 'key',
    key: 'key',
    defaultSortOrder: 'ascend',
    sorter: (a, b) => a.key - b.key
  },
  {
    ellipsis: true,
    align: 'center',
    title: '短信或邮件标题',
    dataIndex: 'title',
    key: 'title',
    sortDirections: ['descend', 'ascend'],
    sorter: (a, b) => a.title.length - b.title.length
  },
  {
    ellipsis: true,
    align: 'center',
    title: '创建时间',
    dataIndex: 'pic',
    key: 'pic',
    sorter: (a, b) => a.type.length - b.type.length,
    sortDirections: ['descend', 'ascend']
  },
  {
    ellipsis: true,
    align: 'center',
    title: '修改时间',
    dataIndex: 'type',
    key: 'type',
    sorter: (a, b) => a.type.length - b.type.length,
    sortDirections: ['descend', 'ascend']
  },
  {
    ellipsis: true,
    align: 'center',
    title: '收件人类型',
    dataIndex: 'auditStatus',
    key: 'auditStatus',
    scopedSlots: { customRender: 'auditStatus' },
    sorter: (a, b) => a.auditStatus - b.auditStatus,
    sortDirections: ['descend', 'ascend']
  },
  {
    ellipsis: true,
    align: 'center',
    title: '关联产品或客户分组',
    dataIndex: 'type',
    key: 'type',
    sorter: (a, b) => a.type.length - b.type.length,
    sortDirections: ['descend', 'ascend']
  },
  {
    title: '操作',
    key: 'operation',
    scopedSlots: { customRender: 'operation' }
  }
];

const data = [
  {
    key: '1',
    title: 'banner',
    orderNumber: 1,
    img: '',
    type: 'index-banner',
    sord: 1,
    status: '未审核',
    publicStatus: '0'
  },
  {
    key: '2',
    title: 'banner',
    orderNumber: 2,
    img: '',
    type: 'index-banner',
    sord: 2,
    status: '审核通过',
    publicStatus: '1'
  },
  {
    key: '3',
    title: 'banner',
    orderNumber: 3,
    img: '',
    type: 'index-banner',
    sord: 3,
    status: '审核通过',
    publicStatus: '1'
  }
];
export default {
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    JDate,
    JImageUpload,
    SMSServiceModal
  },

  name: 'SMSService',
  created() {
    this.getList();
    this.jumpTypeChange();
  },
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 14 },
      settinglabelCol: { span: 9 },
      settingwrapperCol: { span: 10 },
      columns,
      historyColumns,
      data,
      /* table选中keys*/
      selectedRowKeys: [],
      /* table选中records*/
      selectionRows: [],
      query: {
        pageSizeOptions: ['10', '20', '30'],
        pageNo: 1,
        pageSize: 10,
        total: 0
      },
      addTypeVisible: false,
      historyVisible: false,
      settingVisible: false,
      timeVisible: false,
      addVisible: false,
      radioValue: 'a',
      openValue: 'a',
      screenVisible: false,
      editVisible: false,
      checkVisible: false,
      publicText: '',
      loading: false,
      category: '0',
      // 新增banner需要的数据
      bannerForm: {
        fundCode: '',
        category: '0',
        type: '',
        showIndex: null,
        title: '',
        jumpType: '0',
        jumpTarget: '',
        openType: '',
        pic: ''
      },
      queryParam: {},
      bannerRules: {
        type: [
          { required: true, message: 'banner分类不能为空', trigger: 'blur' }
        ],
        showIndex: [
          { required: true, message: '排序不能为空', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '标题不能为空,限制50字', trigger: 'blur' }
        ],
        pic: [{ required: false, message: '图片不能为空', trigger: 'blur' }]
      },
      bannerList: [],
      // 审核设置数据
      settingForm: {
        category: '0',
        type: '',
        createNeedAudit: '',
        editNeedAudit: '',
        auditorSamePublisher: ''
      },
      timeForm: {
        category: '0',
        type: '',
        stayTime: ''
      },
      settingRules: {
        type: [
          { required: true, message: 'banner分类不能为空', trigger: 'blur' }
        ]
      },
      editForm: {},
      editRules: {
        type: [
          { required: true, message: 'banner分类不能为空', trigger: 'blur' }
        ],
        showIndex: [
          { required: true, message: '排序不能为空', trigger: 'blur' }
        ],
        title: [
          {
            required: true,
            message: '标题不能为空,内容不超过50字',
            trigger: 'blur'
          }
        ],
        pic: [{ required: false, message: '图片不能为空', trigger: 'blur' }]
      },
      typeList: [],
      setList: [],
      screen: {
        type: '',
        title: ''
      },
      fundList: [],
      prdDtlUrl: '',
      url: {
        list: process.env.VUE_APP_CMS_CONTENT + '/cont/banner/list',
        add: process.env.VUE_APP_CMS_CONTENT + '/cont/banner/add',
        edit: process.env.VUE_APP_CMS_CONTENT + '/cont/banner/edit',
        delete: process.env.VUE_APP_CMS_CONTENT + '/cont/banner/delete',
        deleteBatch:
          process.env.VUE_APP_CMS_CONTENT + '/cont/banner/deleteBatch',
        audit: process.env.VUE_APP_CMS_CONTENT + '/cont/banner/audit',
        auditBatch: process.env.VUE_APP_CMS_CONTENT + '/cont/banner/auditBatch',
        shelveBatch:
          process.env.VUE_APP_CMS_CONTENT + '/cont/banner/shelveBatch',
        typeList: process.env.VUE_APP_CMS_CONTENT + '/cont/banner/typeList',
        setList: process.env.VUE_APP_CMS_CONTENT + '/cont/banner/setList',
        publishSetUrl:
          process.env.VUE_APP_CMS_CONTENT + '/cont/banner/publishSet',
        fundList:
          process.env.VUE_APP_CMS_PRODUCT + '//product/fundInfo/listAll',
        prdDtlUrl: process.env.VUE_APP_CMS_CONTENT + '/cont/banner/getPrdDtlUrl'
      }
    };
  },
  methods: {
    // 获取表格数据
    getList() {
      getAction(this.url.list, {
        title: this.screen.title,
        type: this.screen.type,
        category: this.category,
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize
      }).then(res => {
        if (res.success) {
          this.bannerList = res.result.records;
          this.bannerList.forEach((item, index) => {
            (item.statusBl = item.status == '1' ? true : false),
              (item.key = index + 1);
          });
          this.query.total = res.result.total;
        }
        if (this.screenVisible) {
          this.screenVisible = false;
        }
      });
    },
    addHandle() {
      this.addVisible = true;
      this.bannerForm = {};
      this.getTypeList();
    },
    addTypeHandle() {
      this.addTypeVisible = true;
    },
    historyHandle() {
      this.historyVisible = true;
    },
    // 修改
    editBanner(record) {
      this.editVisible = true;
      this.editForm = { ...record };
      console.log(this.editForm);
    },

    //单个审核
    auditBanner(record) {
      this.checkVisible = true;
      this.editForm = record;
      console.log(this.editForm);
    },

    // 点击筛选按钮触发
    onScreen() {
      this.screenVisible = true;
      this.getTypeList();
    },
    getTypeList() {
      getAction(this.url.typeList, { category: this.category }).then(res => {
        if (res.success) {
          this.typeList = res.result;
        }
      });
    },

    getSetList() {
      getAction(this.url.setList, { category: this.category }).then(res => {
        if (res.success) {
          this.setList = [];
          this.setList = res.result;
          //console.log(this.setList)
          this.typeList = [];
          var that = this;
          this.setList.forEach(function(s) {
            that.typeList.push(s.type);
          });
        }
      });
    },
    handleTypeChange(type) {
      var that = this;
      this.setList.forEach(function(c) {
        if (type == c.type) {
          that.settingForm.createNeedAudit = c.createNeedAudit;
          that.settingForm.editNeedAudit = c.editNeedAudit;
          that.settingForm.auditorSamePublisher = c.auditorSamePublisher;
          //console.log(that.settingForm)
        }
      });
    },

    // 选择框选中时触发
    onSelectChange(selectedRowKeys, selectionRows) {
      console.log('selectedRowKeys changed: ', selectedRowKeys, selectionRows);
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    // 排序时触发
    onChange(pagination, filters, sorter) {
      // console.log('params', pagination, filters, sorter);
    },
    // 删除
    onDelete(id) {
      var that = this;
      this.$confirm({
        title: '确认删除',
        content: '是否删除选中数据?',
        onOk: function() {
          that.loading = true;
          postAction(that.url.delete, { id: id })
            .then(res => {
              if (res.success) {
                that.$message.success(res.message);
                that.query.pageNo = 1;
                that.getList();
                that.onClearSelected();
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        }
      });
    },
    onShowSizeChange(current, pageSize) {
      this.query.pageSize = pageSize;
      this.getList();
    },
    onChangeCurrent(current) {
      this.query.pageNo = current;
      this.getList();
    },
    // 点击审核对话框确定按钮时触发
    historyHandleOk() {
      this.$refs.settingRuleForm.validate(bool => {
        if (!bool) return;
        (this.settingForm.category = this.category),
          postAction(this.url.publishSetUrl, this.settingForm).then(res => {
            if (res.success) {
              this.$message.success(res.message);
            }
          });
        if (this.addTypeVisible) {
          this.addTypeVisible = false;
        }
        (this.settingForm = {}), (this.settingVisible = false);
      });
    },
    historyCancel() {
      this.$refs.settingRuleForm.resetFields();
    },

    // 点击轮播时间确定按钮触发
    timeHandleOk() {
      this.$refs.settingRuleForm.validate(bool => {
        if (!bool) return;
        (this.timeForm.category = this.category),
          postAction(this.url.publishSetUrl, this.timeForm).then(res => {
            if (res.success) {
              this.$message.success(res.message);
            }
          });
        this.timeForm = {
          category: '0',
          type: '',
          stayTime: ''
        };
        this.timeVisible = false;
      });
    },
    // 轮播时间设置中的选择类型
    handleChangeTypeTime(value, option) {
      console.log(value);
      this.timeForm.stayTime = this.typeList[option.data.key].stayTime;
    },

    // 点击新增对话框确定时触发
    addHandleOk() {
      this.$refs.bannerRuleForm.validate(bool => {
        if (!bool) return;
        this.bannerForm.category = '0';
        postAction(this.url.add, this.bannerForm).then(res => {
          if (res.success) {
            this.getList();
          }
          Object.keys(this.bannerForm).forEach(
            key => (this.bannerForm[key] = '')
          );
        });
        this.addVisible = false;
      });
    },
    addCancel() {
      this.$refs.bannerRuleForm.resetFields();
    },

    // 选择要跳转的栏目 value为产品代码
    handleFundChange(value) {
      console.log(this.editForm.fundCode);
      let jumpTarget = '';
      if (this.bannerForm.jumpType == 0 || this.editForm.jumpType == 0) {
        this.jumpTypeChange();
        if (this.editForm.fundCode) {
          jumpTarget =
            process.env.VUE_APP_H5_URL +
            this.prdDtlUrl.h5 +
            this.editForm.fundCode; //fundDetailOpen?fundCode=
        }
        if (this.bannerForm.fundCode) {
          jumpTarget =
            process.env.VUE_APP_H5_URL +
            this.prdDtlUrl.h5 +
            this.bannerForm.fundCode; //fundDetailOpen?fundCode=
        }
      }
      if (this.bannerForm.jumpType == 1 || this.editForm.jumpType == 1) {
        if (this.editForm.fundCode) {
          jumpTarget =
            process.env.VUE_APP_PC_URL +
            this.prdDtlUrl.pc +
            this.editForm.fundCode; //fundDetailOpen?fundCode=
        }
        if (this.bannerForm.fundCode) {
          jumpTarget =
            process.env.VUE_APP_PC_URL +
            this.prdDtlUrl.pc +
            this.bannerForm.fundCode; //fundDetailOpen?fundCode=
        }
      }
      this.editForm.jumpTarget = jumpTarget;
      this.bannerForm.jumpTarget = jumpTarget;
    },
    // 切换打开方式
    openChange(value) {
      this.openValue = value.target.value;
    },

    // 点击确认修改按钮时触发
    editHandleOk() {
      // console.log(this.editForm)
      this.$refs.editRuleForm.validate(bool => {
        if (!bool) return;
        postAction(this.url.edit, this.editForm).then(res => {
          if (res.success) {
            this.getList();
            this.$message.success('修改成功');
          }
        });
        this.editVisible = false;
      });
    },

    // 点击审核通过或审核驳回时触发
    checkHandleOk(opt) {
      getAction(this.url.audit, { opt: opt, ids: this.editForm.id }).then(
        res => {
          if (res.success) {
            this.$message.success(res.message);
            this.getList();
          }
        }
      );
      this.checkVisible = false;
    },

    // 点击（批量）审核通过按钮时触发
    checkConfirm() {},

    // 点击审核驳回时触发
    checkCancel() {},

    handleShelve(record) {
      let strOpen = '确定要上架所选数据?';
      let strClose = '确定要下架所选数据?';
      let data = {
        bannerList: [],
        type: ''
      };
      data.bannerList.push(record);
      var that = this;
      this.$confirm({
        title: record.statusBl ? '数据上架' : '数据下架',
        content: record.statusBl ? strOpen : strClose,
        onOk() {
          data.type = record.statusBl ? '1' : '0';
          postAction(that.url.shelveBatch, {
            bannerDtoList: JSON.stringify(data)
          }).then(res => {
            if (res.success) {
              that.$message.success(res.message);
            } else {
              that.$message.error(res.message);
              record.statusBl = !record.statusBl;
            }
          });
        },
        onCancel() {
          record.statusBl = !record.statusBl;
        }
      });
    },
    // searchReset() {
    //   this.screenVisible = true
    //   this.screen.type = ''
    //   this.screen.title = ''
    // },
    isDisabled(audit) {
      if (audit == '1') {
        return false;
      } else {
        return true;
      }
    },
    //批量删除
    batchDel() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function() {
            that.loading = true;
            postAction(that.url.deleteBatch, { ids: ids })
              .then(res => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.query.pageNo = 1;
                  that.getList();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          }
        });
      }
    },

    //批量审核或驳回
    batchAudit(opt) {
      var ids = '';
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      }
      for (var a = 0; a < this.selectionRows.length; a++) {
        if (this.selectionRows[a].auditStatus == '0') {
          ids += this.selectionRows[a].id + ',';
        }
      }
      if (ids.length <= 0) {
        this.$message.warning('请选择一条有效的记录！');
        return;
      }
      var that = this;
      this.$confirm({
        title: '审核',
        content: '确定审核' + (opt == '1' ? '通过' : '驳回') + '?',
        onOk: function() {
          that.loading = true;
          getAction(that.url.auditBatch, { ids: ids, opt: opt })
            .then(res => {
              if (res.success) {
                that.$message.success(res.message);
                that.getList();
                that.onClearSelected();
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        }
      });
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    publishSet() {
      this.settingVisible = true;
      //this.getTypeList()
      this.getSetList();
    },
    timeSet() {
      (this.timeVisible = true), this.getTypeList();
    },

    /** 批量上架下架操作*/
    batchShelve(opt) {
      var bannerList = [];
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      }
      for (var a = 0; a < this.selectionRows.length; a++) {
        if (
          this.selectionRows[a].auditStatus == '1' &&
          '0' == opt &&
          this.selectionRows[a].status == '1'
        ) {
          bannerList.push(this.selectionRows[a]);
        } else if (
          this.selectionRows[a].auditStatus == '1' &&
          '1' == opt &&
          this.selectionRows[a].status != '1'
        ) {
          bannerList.push(this.selectionRows[a]);
        }
      }
      if (bannerList.length <= 0) {
        this.$message.warning('请选择一条有效的记录！');
        return;
      }
      let optStr = opt == '0' ? '下架' : '上架';
      //let iptOppStr = (opt == '1')? "下架" : "上架"
      var that = this;
      let data = {
        bannerList: bannerList,
        type: opt
      };
      this.$confirm({
        title: '数据' + optStr,
        content: '确定' + optStr + '所选数据？',
        onOk: function() {
          that.loading = true;
          postAction(that.url.shelveBatch, {
            bannerDtoList: JSON.stringify(data)
          })
            .then(res => {
              if (res.success) {
                that.$message.success(res.message);
                that.getList();
                that.onClearSelected();
              } else {
                that.$message.error(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        }
      });
    },
    goSearch() {
      (this.query.pageNo = 1), this.getList();
    },

    jumpTypeChange() {
      getAction(this.url.fundList, {}).then(res => {
        if (res.success) {
          this.fundList = res.result;
        }
      });
      getAction(this.url.prdDtlUrl, {}).then(res => {
        if (res.success) {
          if (res.result != null) {
            this.prdDtlUrl = res.result;
          } else {
            this.$message.error('尚未配置banner跳转产品详情的链接，请配置！');
          }
        } else {
          this.$message.error('获取banner跳转产品详情的链接异常！');
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.banner_container {
  .banner_title {
    display: flex;

    .title {
      flex: 3;
      font-size: 22px;
      color: #333;
    }

    .btns {
      flex: 2;

      .ant-btn {
        margin-right: 20px;
      }
    }
  }

  .banner_btns {
    margin-top: 20px;
    margin-bottom: 20px;

    .ant-btn {
      margin-right: 10px;
    }
  }

  .ant-table-wrapper {
    margin-bottom: 30px;
  }

  .bannerImg {
    display: flex;

    .img_item {
      width: 250px;
      height: 170px;

      img {
        display: inline-block;
        width: 100%;
        height: 100%;
      }
    }
  }
  .ant-pagination {
    float: right;
    background: #fff;
  }
}
</style>
